<!-- Policy Timeline Component -->

<div *ngIf="showWarning" class="warning-banner">
  <mat-icon>warning</mat-icon>
  <span>Your policy is pending review. Please check back later for updates.</span>
</div>

<div class="progress-section">
      <div class="progress-content">
        <!-- Progress Header -->
        <div class="progress-header" 
             fxLayout="column" 
             fxLayoutAlign="center center"
             fxLayoutGap="8px">
          <h2>Your Policy Progress</h2>
          <p>Track your application from start to finish</p>
        </div>

        <!-- Progress Tracker -->
        <div class="progress-tracker" fxLayout="column" fxLayoutAlign="center stretch">
          
          <!-- Main Progress Steps -->
          <div class="progress-steps" 
               fxLayout="row" 
               fxLayout.xs="column"
               fxLayoutAlign="space-between start"
               fxLayoutAlign.xs="center stretch"
               fxLayoutGap="0px"
               fxLayoutGap.xs="32px">
            
            <div class="step" 
                 *ngFor="let step of processedSteps; let i = index; let isLast = last"
                 fxLayout="column" 
                 fxLayoutAlign="start center"
                 fxFlex="1"
                 fxFlex.xs="none"
                 [style.opacity]="stepOpacity(step)">
              <div class="step-circle" [ngClass]="stepClass(step)">
                <svg *ngIf="step.icon === 'check'" width="100" height="100" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div *ngIf="step.icon === 'document'" class="current-icon">
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                    <rect x="6" y="4" width="12" height="16" rx="2" fill="white"/>
                    <path d="M8 2V6M16 2V6" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                </div>
                <div *ngIf="step.icon === 'reject'" class="declined-icon">
                  <svg width="100" height="100" viewBox="0 0 24 24" fill="none">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#9ca3af" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </div>
              </div>

              <!-- Connector line (hidden on mobile) -->
              <div class="step-connector" 
                   *ngIf="!isLast" 
                   fxHide.xs
                   [ngClass]="connectorClass(step, isLast)">
              </div>

              <div class="step-info" 
                   fxLayout="column" 
                   fxLayoutAlign="start center"
                   fxLayoutGap="4px">
                <h3>{{ step.title }}</h3>
                <p>{{ step.date | date:'MMM d, y' }}</p>
              </div>
            </div>
          </div>

          <!-- Declined Branch -->
          <div class="declined-branch" 
               *ngIf="hasDeclined"
               fxHide.xs
               [ngClass]="declinedConnectorClass()">
            <div class="declined-step-connector" 
                 [class.completed]="isUnderReviewCompleted()"
                   [ngClass]="declinedConnectorClass()"
                   fxHide.xs>
            </div>
            <div class="declined-connector"
                 [class.completed]="isUnderReviewCompleted()"
                 [ngClass]="declinedConnectorClass()"></div>
            <div class="declined-step">
              <div class="step-circle" [ngClass]="declinedStepClass()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6L18 18" stroke="white" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </div>
              <div class="step-info">
                <h3>Declined</h3>
                <p>{{ declinedStep?.date ? (declinedStep.date | date:'MMM d, y') : 'N/A' }}</p>
              </div>
              
            </div>
          </div>

          <!-- Mobile Declined Step -->
          <div class="declined-step-mobile" 
               *ngIf="hasDeclined"
               fxLayout="column" 
               fxLayoutAlign="start center"
               fxLayoutGap="12px"
               fxHide
               fxShow.xs>
            <div class="step-circle" [ngClass]="declinedStepClass()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6L18 18" stroke="#9ca3af" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
            <div class="step-info" 
                 fxLayout="column" 
                 fxLayoutAlign="start center"
                 fxLayoutGap="4px">
              <h3>Declined</h3>
              <p>{{ declinedStep?.date || 'N/A' }}</p>
            </div>
          </div>
        </div>
        
        <!-- Action Buttons -->
        <div class="action-buttons" 
             fxLayout="row" 
             fxLayout.xs="column"
             fxLayoutAlign="center center"
             fxLayoutGap="16px">
          <button class="btn btn-approved" 
                  *ngIf="shouldShowApprovedButton()"
                  fxFlex="0 0 auto"
                  fxFlex.xs="1 1 auto"
                 >
            {{ approvedButtonText() }}
          </button>
          <button class="btn btn-declined" 
                  *ngIf="shouldShowDeclinedButton()"
                  fxFlex="0 0 auto"
                  fxFlex.xs="1 1 auto"
                >
            {{ declinedButtonText() }}
          </button>
        </div>
      </div>
    </div>